import React, { useState, useEffect, useRef } from 'react';

import Modal from 'react-modal';

const AddLicenseModal = ({
  showModal,
  setShowModal,
  handleSave,
  license,
  isEdit,
  licenseFeature,
}) => {
  const fields = ['type', 'state', 'number', 'expirationDate'];
  const [data, setData] = useState({
    type: '',
    state: '',
    number: '',
    expirationDate: '',
  });
  const [dataError, setDataError] = useState({});

  useEffect(() => {
    if (license) {
      setData(license);
    }
  }, [license]);

  const handleCloseModal = () => {
    setShowModal(false);
    setData({});
  };

  const handleSubmit = () => {
    let hasError = false;
    setDataError({});
    fields.map((key) => {
      if (!data[key]) {
        hasError = true;
        setDataError({
          ...dataError,
          [key]: 'The field is required',
        });
      }
    });
    if (hasError) {
      return false;
    }

    handleSave(data);
    handleCloseModal();
  };

  const handleChange = (e, name) => {
    setData({
      ...data,
      [name]: e.target.value,
    });
  };
  const stateOptions = licenseFeature.format?.state.options;
  return (
    <Modal isOpen={showModal} className="insurance-modal field-modal">
      <div>
        <span className="close" onClick={() => handleCloseModal()}>
          x
        </span>
        <div className="modal-header">{isEdit ? 'Edit' : 'Add'} License</div>
        <div className="modal-content form-part">
          <div className="form-list">
            <div className={`form-group ${dataError['type'] ? 'error' : ''}`}>
              <div className="form-field">
                <label htmlFor="type">
                  Type
                  {/* <span className="required">*</span> */}
                </label>
                <input
                  id="type"
                  onChange={(e) => handleChange(e, 'type')}
                  value={data['type']}
                  name="type"
                  className={dataError['type'] ? 'error' : ''}
                  placeholder="License Type"
                />
                {dataError['type'] && <p className="error-text">{dataError['type']}</p>}
              </div>
            </div>
            <div className={`form-group ${dataError['state'] ? 'error' : ''}`}>
              <div className="form-field">
                <label htmlFor="state">
                  State
                  {/* <span className="required">*</span> */}
                </label>
                <select
                  id="state"
                  value={data['state']}
                  name="state"
                  onChange={(e) => handleChange(e, 'state')}
                  className={dataError['state'] ? 'error' : ''}
                  placeholder="State"
                >
                  <option value="">Select an option</option>
                  {stateOptions.map((option, index) => (
                    <option value={option.value} key={'option' + option.value + index}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {dataError['state'] && <p className="error-text">{dataError['state']}</p>}
              </div>
            </div>
            <div className={`form-group ${dataError['number'] ? 'error' : ''}`}>
              <div className="form-field">
                <label htmlFor="number">
                  Number
                  {/* <span className="required">*</span> */}
                </label>
                <input
                  id="number"
                  value={data['number']}
                  name="number"
                  onChange={(e) => handleChange(e, 'number')}
                  className={dataError['number'] ? 'error' : ''}
                  placeholder="Number"
                  spellCheck={false}
                />
                {dataError['number'] && <p className="error-text">{dataError['number']}</p>}
              </div>
            </div>
            <div className={`form-group ${dataError['expirationDate'] ? 'error' : ''}`}>
              <div className="form-field">
                <label htmlFor="expirationDate">
                  Expiration Date
                  <span className="required">*</span>
                </label>
                <input
                  id="expirationDate"
                  value={data['expirationDate']}
                  name="expirationDate"
                  type="date"
                  onChange={(e) => handleChange(e, 'expirationDate')}
                  className={dataError['expirationDate'] ? 'error' : ''}
                  placeholder="Expiration Date"
                  max="2199-12-12"
                  spellCheck={false}
                />
                {dataError['expirationDate'] && (
                  <p className="error-text">{dataError['expirationDate']}</p>
                )}
              </div>
            </div>
          </div>
          <div className="action-button">
            <button type="button float-right" onClick={handleSubmit}>
              {isEdit ? 'Edit' : 'Add'} License
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddLicenseModal;
